import script from "./finish-import.vue?vue&type=script&lang=ts&setup=true"
export * from "./finish-import.vue?vue&type=script&lang=ts&setup=true"

import "./finish-import.vue?vue&type=style&index=0&id=787dedf4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787dedf4"]])

export default __exports__